import { create } from "zustand";
import { Vector3 } from "three";

export interface ScreenPosition {
    x: number;
    y: number;
}

export interface HoveredEditHandleState {
    position: Vector3 | null;
    tooltipKey: string | null;
    screenPosition: ScreenPosition | null;

    setHoveredEditHandle: (position: Vector3, tooltipKey: string) => void;
    setScreenPosition: (screenPosition: ScreenPosition) => void;
    clearHoveredEditHandle: () => void;
}

export const useHoveredEditHandleStore = create<HoveredEditHandleState>()(
    (set) => ({
        position: null,
        tooltipKey: null,
        screenPosition: null,

        setHoveredEditHandle: (position: Vector3, tooltipKey: string) =>
            set({ position, tooltipKey }),

        setScreenPosition: (screenPosition: ScreenPosition) =>
            set({ screenPosition }),

        clearHoveredEditHandle: () =>
            set({ position: null, tooltipKey: null, screenPosition: null }),
    })
);
